import { Box, Typography } from "@mui/material";
import React from "react";
import { Button } from "../../../common/buttons";
import { FormattedMessage } from "react-intl";
import "./styles.less";

type RequestDetailedActionsProps = {
    currentStage: string;
    onProcessClick: () => void;
    onCancelProcessClick: () => void;
    onApproveClick: () => void;
    onRejectClick: () => void;
    onSaveAndContinueClick: () => void;
    onSaveClick: () => void;
    disabled: boolean;
};

const commonApproveReject = {
    approve: "request-detailed-actions.btn-approve-stage",
    reject: "request-detailed-actions.btn-reject-stage",
};

const stageActions: Record<string, { approve: string; reject: string }> = {
    TEST_APPROVEMENT: {
        approve: "request-detailed-actions.btn-approve-testing-stage",
        reject: "request-detailed-actions.btn-reject-testing-stage",
    },
    ROLE_OWNER_APPROVEMENT: commonApproveReject,
    RISK_MANAGE_APPROVEMENT: commonApproveReject,
    INFSEC_APPROVEMENT: commonApproveReject,
     // ROLE_DEFINITION: {
    //     approve: "request-detailed-actions.btn-approve-role- definition-stage",
    //     reject: "request-detailed-actions.btn-reject-role-definition-stage",
    // },
};

const   RequestDetailedActions: React.FC<RequestDetailedActionsProps> = ({
    currentStage,
    // onProcessClick,
    // onCancelProcessClick,
    onApproveClick,
    onRejectClick,
    onSaveAndContinueClick,
    onSaveClick,
    disabled
}) => {
    const actions = stageActions[currentStage] || null;
    return (
        <Box className="request-detailed-actions">
            <Box display="flex">
                <Box display="flex" gap={2}>
                    {/* <Button variant="contained" className="request-detailed-actions-button-contained" onClick={onProcessClick}>
                        <FormattedMessage id="request-detailed-actions.btn-process" />
                    </Button>
                    <Button variant="outlined" className="request-detailed-actions-button-outlined" onClick={onCancelProcessClick}>
                        <FormattedMessage id="request-detailed-actions.btn-cancel-process" />
                    </Button> */}
                </Box>

                {/* <Divider orientation="vertical" flexItem sx={{ mx: 2 }} /> */}

                {actions  && (
                    <Box display="flex" gap={2}>
                        <Button disabled={disabled} variant="contained" className="request-detailed-actions-button-contained" onClick={onApproveClick}>
                            <FormattedMessage id={actions.approve} />
                        </Button>
                        <Button disabled={disabled}  variant="outlined" className="request-detailed-actions-button-outlined" onClick={onRejectClick}>
                            <FormattedMessage id={actions.reject} />
                        </Button>
                    </Box>
                )}
            </Box>

            {currentStage == "ROLE_DEFINITION" && (
                <Box className="request-detailed-actions-confirmation">
                    <Typography className="request-detailed-actions-confirmation-text">
                        <FormattedMessage id="request-detailed-actions.confirmation-testing" />
                    </Typography>
                    <Box display="flex" gap={2}>
                        <Button disabled={disabled}  className="request-detailed-actions-button-contained" variant="contained" onClick={onSaveAndContinueClick}>
                            <FormattedMessage id="request-detailed-actions.btn-save-and-continue" />
                        </Button>
                        <Button disabled={disabled}  className="request-detailed-actions-button-outlined" variant="outlined" onClick={onSaveClick}>
                            <FormattedMessage id="request-detailed-actions.btn-save" />
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default RequestDetailedActions;
